import { render, staticRenderFns } from "./StatsByCorrectAnswer.vue?vue&type=template&id=6e0d7dae&scoped=true&"
import script from "./StatsByCorrectAnswer.vue?vue&type=script&lang=ts&"
export * from "./StatsByCorrectAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./StatsByCorrectAnswer.vue?vue&type=style&index=0&id=6e0d7dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0d7dae",
  null
  
)

export default component.exports